import React from 'react';
import {ItemPresenter} from "../ItemPresenter";

const className = "wildboarpelt";

function GIWildBoarPelt() {
  return (
    <ItemPresenter imagePath={`/images/gameItems/${className}.png`} tooltipText={className} />
  );
}

export default GIWildBoarPelt;